import React, { Component } from 'react';
import _ from 'lodash';
import {
    WithStyles, createStyles, Typography, Button, Grid
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { MyPATDialog } from '../../../../common';
import { videoActions } from '../../../reducers/videoCreateContentReducers';
import VideoPublishFinish from './VideoPublishFinish';
import CircularProgressBar from './CircularProgressBar';
import contentService from '../../../services/contentService';
import { showMsg } from '../../../../course/actions/loaderAlert';

const styles = (theme: Theme) => createStyles({
});

interface PublishVideoModalProps extends WithStyles<typeof styles> {
    publishProgressPercentage: number;
    previewFile: boolean;
    previewPublishedFile: Function;
    handlePublishVideoModal: Function;
    isPublishVideoModalOpen: boolean;
    save: Function;
    changePublishPercentage: Function;
    resetVideoModalState: Function;
    showMsg: Function;
    history: any;
    forAudio: boolean;
}

interface PublishVideoModalState {
    publishedContentId: any
    publishProgressText: string
}

class PublishVideoModal extends Component<PublishVideoModalProps, PublishVideoModalState> {
    constructor(props: PublishVideoModalProps) {
        super(props);
        this.state = {
            publishedContentId: '',
            publishProgressText: 'Publishing in progress'
        }
    }

    componentDidUpdate = (prevProps: any, prevState: any) => {
        if ((prevProps.isPublishVideoModalOpen !== this.props.isPublishVideoModalOpen) && this.props.isPublishVideoModalOpen) {
            _.delay(this.handlePublishRequest, 4000);
            
        }
    }

    handlePublishRequest = async () => {
        try {
            let video = await this.props.save(true);
            let audioType = false;
            if (video.audio) {
                audioType = true;
            }
            video = video.audio || video;
            if (!video._id) {
                throw new Error();
            }
            let publishedResponse: any = {};
            this.props.changePublishPercentage(50);
            if (video.draftId) {
                const res = await contentService.publishVideoContent(video.draftId, audioType ? 'audios' : 'videos');
                publishedResponse = res.audio || res.video;
            } else {
                const res = await contentService.publishVideoContent(video, audioType ? 'audios' : 'videos');
                publishedResponse = res.audio || res.video;
            }
            this.setState({ publishedContentId: publishedResponse.contentId })
            this.props.changePublishPercentage(100);
            this.setState({ publishProgressText: 'Publishing completed' });
        } catch (err) {
            this.props.showMsg('Failed to publish the content', 'error')
            this.props.changePublishPercentage(0)
        }
    }

    closePublishModal = () => {
        if (this.props.publishProgressPercentage >= 100) {
            this.props.resetVideoModalState();
            this.props.handlePublishVideoModal(false);
            window.open('/mylibrary', '_self');
        } else {
            this.props.handlePublishVideoModal(false);
        }
    }

    render() {
        const {
            publishProgressPercentage,
            previewPublishedFile,
            previewFile,
            isPublishVideoModalOpen,
        } = this.props;
        const { publishedContentId } = this.state;
        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'sm',
            scroll: 'body',
        };
        const heading = window.location.pathname.includes('/audios') ? 'Publish Audio' : 'Publish Video';
        return (
            <>
                <MyPATDialog
                    dialogHeading={heading}
                    dialogOpen={isPublishVideoModalOpen}
                    dialogHasActions={false}
                    customButtonVariant="withoutBorderCloseIcon"
                    onDialogClose={this.closePublishModal}
                    isAlignCenter={true}
                    otherDialogProps={otherDialogProps}
                    isCloseButtonHidden = {publishProgressPercentage !== 100}
                >
                    {
                        !previewFile ? (
                            <>
                                <Grid container xs={12} justify="center" direction="column" alignItems="center" spacing={8}>
                                    <Grid item>
                                        <CircularProgressBar
                                            strokeWidth="15"
                                            sqSize="150"
                                            percentage={publishProgressPercentage}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="body1" align="center">{this.state.publishProgressText}</Typography>
                                    </Grid>
                                    <Grid item >
                                        <Button
                                            disabled={publishProgressPercentage !== 100}
                                            variant="contained"
                                            color="primary"
                                            onClick={() => previewPublishedFile()}
                                        >
                                            View Published File
                                </Button>
                                    </Grid>
                                </Grid>


                            </>
                        ) : <VideoPublishFinish contentId={publishedContentId} />
                    }
                </MyPATDialog>

            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        publishProgressPercentage: state.videoCreateContent.publishProgressPercentage,
        previewFile: state.videoCreateContent.previewFile,
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    previewPublishedFile: videoActions.previewPublishedFile,
    changePublishPercentage: videoActions.changePublishPercentage,
    resetVideoModalState: videoActions.resetVideoModalState,
    showMsg
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PublishVideoModal));